import { parseSearchParams } from '@/routes/helpers/parse-search-params';
import { Link } from '@/ui/link/link';
import { styled } from 'goober';
import { TagWithEllipsis } from './tag-with-ellipsis';
import type { TagSize } from '@/ui/tag/general-tag';

interface TagLinkProps {
  id: string;
  name: string;
  baseUrl?: string;
  size?: TagSize;
}

const TAG_CONFIG = {
  smallScreenMaxWidth: '80px',
  maxWidth: '120px',
  variant: 'blue' as const,
} as const;

const TagAsLink = styled(Link)`
  margin-right: 8px;
  margin-bottom: 5px;
`;

const createTagUrl = (baseUrl: string, id: string): string =>
  baseUrl + parseSearchParams({ tags: id });

const renderTag = (name: string, size: TagSize) => (
  <TagWithEllipsis
    smallScreenMaxWidth={TAG_CONFIG.smallScreenMaxWidth}
    maxWidth={TAG_CONFIG.maxWidth}
    text={name}
    variant={TAG_CONFIG.variant}
    size={size}
  />
);

export const TagLink = ({ id, name, baseUrl, size = 's' }: TagLinkProps) => {
  const tag = renderTag(name, size);

  if (!baseUrl) {
    return tag;
  }

  return <TagAsLink to={createTagUrl(baseUrl, id)}>{tag}</TagAsLink>;
};
